var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46966 8.92105L0.396437 2.8478C0.103531 2.5549 0.103531 2.08002 0.396437 1.78715L1.10478 1.0788C1.39719 0.786397 1.87109 0.785834 2.16419 1.07755L7 5.89071L11.8358 1.07755C12.1289 0.785834 12.6028 0.786397 12.8952 1.0788L13.6035 1.78715C13.8964 2.08005 13.8964 2.55493 13.6035 2.8478L7.53034 8.92105C7.23744 9.21393 6.76256 9.21393 6.46966 8.92105Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a0537e530ea45a707f138c834b814cc5.svg";
export { ForwardRef as ReactComponent };